module.exports = __webpack_public_path__ + "158a353263b8967b70855f444347ac18.png";